import {
	Box,
	Collapse,
	Table,
	TableBody,
	TableCell,
	TableRow,
} from '@mui/material'
import { ReactComponent as ArrowOpenDone } from 'assets/arrow_open_logo.svg'
import { useState } from 'react'
import { TypographyPrimary } from 'ui/typography/TypographyPrimary'
import { TypographySecondary14 } from 'ui/typography/TypographySecondary14'

import { SHIFT_LABELS } from '../../../constants'
import { MilkYieldHistoryItem } from './types'

interface Props {
	history: MilkYieldHistoryItem[]
}

export const MilkYieldHistoryTableBody = ({ history }: Props) => {
	const [openDay, setOpenDay] = useState<string[]>([])
	const handleOpenDay = (date: string) => {
		setOpenDay(prev =>
			prev.includes(date) ? prev.filter(d => d !== date) : [...prev, date],
		)
	}

	return (
		<TableBody
			sx={{
				'& td': {
					paddingTop: '4px',
					paddingBottom: '4px',
				},
			}}
		>
			{history.map(el => (
				<>
					<TableRow
						key={el.date}
						sx={{ '& td': { borderBottom: 'none' }, height: '32px' }}
					>
						<TableCell sx={{ width: '195px', pl: '8px' }}>
							<Box display='flex' alignItems='center' gap='4px'>
								<TypographyPrimary>{el.date}</TypographyPrimary>
								{el.shifts?.length ? (
									<ArrowOpenDone
										onClick={() => handleOpenDay(el.date)}
										style={{
											cursor: 'pointer',
											width: '14px',
											transform: openDay.includes(el.date)
												? 'rotate(0deg)'
												: 'rotate(180deg)',
										}}
									/>
								) : null}
							</Box>
						</TableCell>
						<TableCell sx={{ width: '100px', pl: '24px' }} />
						<TableCell align='left' sx={{ width: '70%', pl: '24px' }}>
							<TypographyPrimary>
								{el.total ? `${el.total.toLocaleString()} л` : '-'}
							</TypographyPrimary>
						</TableCell>
					</TableRow>

					<TableRow sx={{ '& td': { borderBottom: 'none' } }}>
						<TableCell colSpan={3} padding='none'>
							<Collapse
								in={openDay.includes(el.date)}
								timeout='auto'
								unmountOnExit
							>
								<Table size='small'>
									<TableBody>
										{el.shifts?.map((shift, index) => (
											<TableRow
												key={index}
												sx={{
													'& td': { borderBottom: 'none', py: 0 },
												}}
											>
												<TableCell sx={{ width: '195px', pl: '8px', py: 0 }}>
													{/* <TypographySecondary14>
															{shift.time}
														</TypographySecondary14> */}
												</TableCell>
												<TableCell sx={{ width: '100px', pl: '24px', py: 0 }}>
													<TypographySecondary14>
														{SHIFT_LABELS[shift.shiftKey]}
													</TypographySecondary14>
												</TableCell>
												<TableCell
													align='left'
													sx={{ width: '70%', pl: '24px', py: 0 }}
												>
													<TypographySecondary14>
														{shift.value.toLocaleString()} л
													</TypographySecondary14>
												</TableCell>
											</TableRow>
										))}
									</TableBody>
								</Table>
							</Collapse>
						</TableCell>
					</TableRow>
				</>
			))}
			<TableRow sx={{ '& td': { borderBottom: 'none' }, height: '32px' }}>
				<TableCell colSpan={3} sx={{ pl: '8px' }}>
					<TypographySecondary14>Всего: {history.length}</TypographySecondary14>
				</TableCell>
			</TableRow>
		</TableBody>
	)
}
